import * as ambassadorWixEventsV1TicketReservation from './events-v1-ticket-reservation-ticket-reservations.http.js';
import * as ambassadorWixEventsV1TicketReservationTypes from './events-v1-ticket-reservation-ticket-reservations.types.js';
import * as ambassadorWixEventsV1TicketReservationUniversalTypes from './events-v1-ticket-reservation-ticket-reservations.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createTicketReservation(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsV1TicketReservationUniversalTypes.CreateTicketReservationRequest,
  ambassadorWixEventsV1TicketReservationTypes.CreateTicketReservationRequest,
  ambassadorWixEventsV1TicketReservationUniversalTypes.CreateTicketReservationResponse,
  ambassadorWixEventsV1TicketReservationTypes.CreateTicketReservationResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEventsV1TicketReservation.createTicketReservation(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/ticket-reservations',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getTicketReservation(): __PublicMethodMetaInfo<
  'GET',
  { ticketReservationId: string },
  ambassadorWixEventsV1TicketReservationUniversalTypes.GetTicketReservationRequest,
  ambassadorWixEventsV1TicketReservationTypes.GetTicketReservationRequest,
  ambassadorWixEventsV1TicketReservationUniversalTypes.GetTicketReservationResponse,
  ambassadorWixEventsV1TicketReservationTypes.GetTicketReservationResponse
> {
  const payload = { ticketReservationId: ':ticketReservationId' } as any;

  const getRequestOptions =
    ambassadorWixEventsV1TicketReservation.getTicketReservation(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/ticket-reservations/{ticketReservationId}',
    pathParams: { ticketReservationId: 'ticketReservationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteTicketReservation(): __PublicMethodMetaInfo<
  'DELETE',
  { ticketReservationId: string },
  ambassadorWixEventsV1TicketReservationUniversalTypes.DeleteTicketReservationRequest,
  ambassadorWixEventsV1TicketReservationTypes.DeleteTicketReservationRequest,
  ambassadorWixEventsV1TicketReservationUniversalTypes.DeleteTicketReservationResponse,
  ambassadorWixEventsV1TicketReservationTypes.DeleteTicketReservationResponse
> {
  const payload = { ticketReservationId: ':ticketReservationId' } as any;

  const getRequestOptions =
    ambassadorWixEventsV1TicketReservation.deleteTicketReservation(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/ticket-reservations/{ticketReservationId}',
    pathParams: { ticketReservationId: 'ticketReservationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateTicketReservationTags(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsV1TicketReservationUniversalTypes.BulkUpdateTicketReservationTagsRequest,
  ambassadorWixEventsV1TicketReservationTypes.BulkUpdateTicketReservationTagsRequest,
  ambassadorWixEventsV1TicketReservationUniversalTypes.BulkUpdateTicketReservationTagsResponse,
  ambassadorWixEventsV1TicketReservationTypes.BulkUpdateTicketReservationTagsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEventsV1TicketReservation.bulkUpdateTicketReservationTags(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/ticket-reservations/update-tags',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateTicketReservationTagsByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsV1TicketReservationUniversalTypes.BulkUpdateTicketReservationTagsByFilterRequest,
  ambassadorWixEventsV1TicketReservationTypes.BulkUpdateTicketReservationTagsByFilterRequest,
  ambassadorWixEventsV1TicketReservationUniversalTypes.BulkUpdateTicketReservationTagsByFilterResponse,
  ambassadorWixEventsV1TicketReservationTypes.BulkUpdateTicketReservationTagsByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEventsV1TicketReservation.bulkUpdateTicketReservationTagsByFilter(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/ticket-reservations/update-tags-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function cancelTicketReservation(): __PublicMethodMetaInfo<
  'POST',
  { ticketReservationId: string },
  ambassadorWixEventsV1TicketReservationUniversalTypes.CancelTicketReservationRequest,
  ambassadorWixEventsV1TicketReservationTypes.CancelTicketReservationRequest,
  ambassadorWixEventsV1TicketReservationUniversalTypes.CancelTicketReservationResponse,
  ambassadorWixEventsV1TicketReservationTypes.CancelTicketReservationResponse
> {
  const payload = { ticketReservationId: ':ticketReservationId' } as any;

  const getRequestOptions =
    ambassadorWixEventsV1TicketReservation.cancelTicketReservation(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/ticket-reservations/{ticketReservationId}/cancel',
    pathParams: { ticketReservationId: 'ticketReservationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  TicketReservation as TicketReservationOriginal,
  ReservationStatus as ReservationStatusOriginal,
  ReservationStatusWithLiterals as ReservationStatusWithLiteralsOriginal,
  TicketLineItem as TicketLineItemOriginal,
  TicketInfo as TicketInfoOriginal,
  SeatInfo as SeatInfoOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  PricingPlan as PricingPlanOriginal,
  EventSettingsSnapshot as EventSettingsSnapshotOriginal,
  CheckoutType as CheckoutTypeOriginal,
  CheckoutTypeWithLiterals as CheckoutTypeWithLiteralsOriginal,
  CommonMoney as CommonMoneyOriginal,
  ServiceFee as ServiceFeeOriginal,
  FeeType as FeeTypeOriginal,
  FeeTypeWithLiterals as FeeTypeWithLiteralsOriginal,
  CatalogReference as CatalogReferenceOriginal,
  AdditionalReservationSettings as AdditionalReservationSettingsOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  Tags as TagsOriginal,
  TagList as TagListOriginal,
  TicketReservationBalanceUpdated as TicketReservationBalanceUpdatedOriginal,
  TicketReservationBalance as TicketReservationBalanceOriginal,
  TicketDefinitionBalance as TicketDefinitionBalanceOriginal,
  CreateCheckoutRequest as CreateCheckoutRequestOriginal,
  CreateCheckoutResponse as CreateCheckoutResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  CreateTicketReservationRequest as CreateTicketReservationRequestOriginal,
  CreateTicketReservationResponse as CreateTicketReservationResponseOriginal,
  PromotionErrors as PromotionErrorsOriginal,
  PromotionType as PromotionTypeOriginal,
  PromotionTypeWithLiterals as PromotionTypeWithLiteralsOriginal,
  Error as ErrorOriginal,
  GetTicketReservationRequest as GetTicketReservationRequestOriginal,
  GetTicketReservationResponse as GetTicketReservationResponseOriginal,
  GetCurrentTicketReservationRequest as GetCurrentTicketReservationRequestOriginal,
  GetCurrentTicketReservationResponse as GetCurrentTicketReservationResponseOriginal,
  UpdateTicketReservationRequest as UpdateTicketReservationRequestOriginal,
  UpdateTicketReservationResponse as UpdateTicketReservationResponseOriginal,
  UpdateCurrentTicketReservationRequest as UpdateCurrentTicketReservationRequestOriginal,
  UpdateCurrentTicketReservationResponse as UpdateCurrentTicketReservationResponseOriginal,
  AddTicketsToCurrentTicketReservationRequest as AddTicketsToCurrentTicketReservationRequestOriginal,
  AddTicketsToCurrentTicketReservationResponse as AddTicketsToCurrentTicketReservationResponseOriginal,
  AddTicketsToTicketReservationRequest as AddTicketsToTicketReservationRequestOriginal,
  AddTicketsToTicketReservationResponse as AddTicketsToTicketReservationResponseOriginal,
  RemoveTicketsFromCurrentTicketReservationRequest as RemoveTicketsFromCurrentTicketReservationRequestOriginal,
  RemoveTicketsFromCurrentTicketReservationResponse as RemoveTicketsFromCurrentTicketReservationResponseOriginal,
  RemoveTicketsFromTicketReservationRequest as RemoveTicketsFromTicketReservationRequestOriginal,
  RemoveTicketsFromTicketReservationResponse as RemoveTicketsFromTicketReservationResponseOriginal,
  DeleteTicketReservationRequest as DeleteTicketReservationRequestOriginal,
  DeleteTicketReservationResponse as DeleteTicketReservationResponseOriginal,
  DeleteCurrentTicketReservationRequest as DeleteCurrentTicketReservationRequestOriginal,
  DeleteCurrentTicketReservationResponse as DeleteCurrentTicketReservationResponseOriginal,
  BulkUpdateTicketReservationTagsRequest as BulkUpdateTicketReservationTagsRequestOriginal,
  BulkUpdateTicketReservationTagsResponse as BulkUpdateTicketReservationTagsResponseOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkUpdateTicketReservationTagsResult as BulkUpdateTicketReservationTagsResultOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  BulkUpdateTicketReservationTagsByFilterRequest as BulkUpdateTicketReservationTagsByFilterRequestOriginal,
  BulkUpdateTicketReservationTagsByFilterResponse as BulkUpdateTicketReservationTagsByFilterResponseOriginal,
  ConfirmTicketReservationRequest as ConfirmTicketReservationRequestOriginal,
  ConfirmTicketReservationResponse as ConfirmTicketReservationResponseOriginal,
  CancelTicketReservationRequest as CancelTicketReservationRequestOriginal,
  CancelTicketReservationResponse as CancelTicketReservationResponseOriginal,
  CancelTicketReservationOnGracePeriodEndRequest as CancelTicketReservationOnGracePeriodEndRequestOriginal,
  CancelTicketReservationOnGracePeriodEndResponse as CancelTicketReservationOnGracePeriodEndResponseOriginal,
  ExpireTicketReservationRequest as ExpireTicketReservationRequestOriginal,
  ExpireTicketReservationResponse as ExpireTicketReservationResponseOriginal,
  UpdateTicketReservationCancelableRequest as UpdateTicketReservationCancelableRequestOriginal,
  UpdateTicketReservationCancelableResponse as UpdateTicketReservationCancelableResponseOriginal,
  Empty as EmptyOriginal,
  OrderArchived as OrderArchivedOriginal,
  OrderStatus as OrderStatusOriginal,
  OrderStatusWithLiterals as OrderStatusWithLiteralsOriginal,
  Ticket as TicketOriginal,
  CheckIn as CheckInOriginal,
  Money as MoneyOriginal,
  FormResponse as FormResponseOriginal,
  InputValue as InputValueOriginal,
  FormattedAddress as FormattedAddressOriginal,
  Address as AddressOriginal,
  AddressStreetOneOf as AddressStreetOneOfOriginal,
  StreetAddress as StreetAddressOriginal,
  AddressLocation as AddressLocationOriginal,
  Subdivision as SubdivisionOriginal,
  SubdivisionType as SubdivisionTypeOriginal,
  SubdivisionTypeWithLiterals as SubdivisionTypeWithLiteralsOriginal,
  StandardDetails as StandardDetailsOriginal,
  OnlineConferencingLogin as OnlineConferencingLoginOriginal,
  OrderUnarchived as OrderUnarchivedOriginal,
  OrderTicketsCanceled as OrderTicketsCanceledOriginal,
  QueryEventsWithPaidReservationsRequest as QueryEventsWithPaidReservationsRequestOriginal,
  EventKey as EventKeyOriginal,
  QueryEventsWithPaidReservationsResponse as QueryEventsWithPaidReservationsResponseOriginal,
  FixArchivedTicketReservationRequest as FixArchivedTicketReservationRequestOriginal,
  FixArchivedTicketReservationResponse as FixArchivedTicketReservationResponseOriginal,
} from './events-v1-ticket-reservation-ticket-reservations.types.js';
